import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import { createUser } from '../../../hooks/security/user';

const StepperContent = ({
  stepIndex,
  stepContents,
  isCheckboxChecked,
  setIsCheckboxChecked,
  setIsFormSubmitted,
}) => {
  const [nombre, setNombre] = useState('');
  const [apellidos, setApellidos] = useState('');
  const [email, setEmail] = useState('');
  const [telefono, setTelefono] = useState('');
  const [codigoPostal, setCodigoPostal] = useState('');
  const [isValid, setIsValid] = useState(true);
  const [disabled, setDisabled] = useState(false);

  const content = stepContents[stepIndex];

  const normalizePhone = (value) => (value || '').replace(/\s+/g, '');
  const passesServerRegex = (value) => /^\+?\d{6,15}$/.test(String(value || ''));

  const verifyPhone = async (value) => {
    const phone = normalizePhone(value);
    if (!passesServerRegex(phone)) {
      setIsValid(false);
      return false;
    }
    
    try {
      const res = await fetch(process.env.REACT_APP_CHECK_PHONE, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ telefono: phone }),
      });

      if (!res.ok) {
        setIsValid(false);
        return false;
      }

      const data = await res.json();

      const ok = data?.exists === true;

      setIsValid(ok);
      return ok;

    } catch (error) {
      console.error('Error checking phone:', error);
      setIsValid(false);
      return false;
    }
  };

  const handlePhoneBlur = () => {
    verifyPhone(telefono);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (stepIndex !== 2 || disabled) return;
    const phoneOk = await verifyPhone(telefono);
    if (!phoneOk) {
      setIsFormSubmitted(false);
      return;
    }
    try {
      const formData = {
        nombre,
        apellidos,
        email,
        telefono,
        codigo_postal: codigoPostal,
        usuario_insercion: telefono,
        activo: 1,
      };
      const response = await createUser(formData);
      if (response) {
        setIsValid(true);
        setIsFormSubmitted(true);
        setDisabled(true);
      } else {
        setIsFormSubmitted(false);
        setDisabled(false);
      }
    } catch {
      setIsFormSubmitted(false);
      setDisabled(false);
    }
  };

  if (content?.form) {
    return (
      <div>
        <Typography variant="h5" gutterBottom sx={{ color: 'white' }}>
          {content?.title}
        </Typography>
        <form
          noValidate
          onSubmit={handleSubmit}
          autoComplete="off"
          style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}
        >
          <TextField
            label="Nombre"
            variant="outlined"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            InputProps={{ style: { backgroundColor: 'white' } }}
          />
          <TextField
            label="Apellidos"
            variant="outlined"
            value={apellidos}
            onChange={(e) => setApellidos(e.target.value)}
            InputProps={{ style: { backgroundColor: 'white' } }}
          />
          <TextField
            label="Email"
            variant="outlined"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            InputProps={{ style: { backgroundColor: 'white' } }}
          />
          <TextField
            label="Teléfono"
            variant="outlined"
            type="tel"
            value={telefono}
            onChange={(e) => {
              setTelefono(e.target.value);
              if (!isValid) setIsValid(true);
            }}
            onBlur={handlePhoneBlur}
            InputProps={{ style: { backgroundColor: 'white' } }}
          />
          <TextField
            label="Código Postal"
            variant="outlined"
            value={codigoPostal}
            onChange={(e) => setCodigoPostal(e.target.value)}
            InputProps={{ style: { backgroundColor: 'white' } }}
          />
          {!isValid && (
            <p style={{ color: 'red', margin: '0px' }}>
              El teléfono que ha proporcionado no es válido. Por favor introduzca otro télefono.
            </p>
          )}
          <Button
            type="submit"
            variant="contained"
            sx={{ backgroundColor: 'red', color: 'white', '&:hover': { backgroundColor: 'darkred' } }}
            disabled={disabled}
          >
            Enviar
          </Button>
        </form>
      </div>
    );
  }

  return (
    <div>
      <Typography variant="h5" gutterBottom>
        {content?.title}
      </Typography>
      {content?.paragraphs?.map((paragraph, index) => (
        <Typography key={index} paragraph>
          {paragraph}
        </Typography>
      ))}
      {stepIndex === 1 && (
        <FormControlLabel
          control={
            <Checkbox
              checked={isCheckboxChecked}
              onChange={(e) => setIsCheckboxChecked(e.target.checked)}
              sx={{ color: 'white', '&.Mui-checked': { color: 'white' } }}
            />
          }
          label="Acepto los términos y condiciones"
          sx={{ color: 'white' }}
        />
      )}
    </div>
  );
};

export default StepperContent;
